<template>
  <div>
    <!-- OLD DIV VERSION    <div class="col-md-10 col-sm-9 col-md-offset-2 col-sm-offset-3 content container-fluid">-->
    <div class="col-xs-12 content container-fluid">
      <h1>Solicitudes Servicios</h1>
      <div class="wrapper">
        <div class="container-wrapper">
          <div id="alerts-container"></div>
        </div>
      </div>
      <div id="app" class="ui vertical stripe segment">
        <div class="row">
          <div class="col-xs-12 m-t-20">
            <div class="table-responsive">
              <div id="content" class="ui basic segment">
                <table
                  id="table-with-sorting"
                  class="table data-table with-sorting table-striped tablesorter payment-batch-table sortable"
                >
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Fecha</th>
                      <th>Empleado</th>
                      <th>Compañia</th>
                      <th>Ofertas</th>
                      <th>Proveedor</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody v-if="!loadingTable">
                    <tr v-for="transaction in transactions">
                      <td>{{ transaction.id }}</td>
                      <td>{{ transaction.created_at }}</td>
                      <td>{{ transaction.client_name }}</td>
                      <td>{{ transaction.company_name }}</td>
                      <td>{{ transaction.offers.title }}</td>
                      <td>{{ transaction.providers.name }}</td>
                      <td>
                        <a
                          class="btn btn-primary btn-xs"
                          data-toggle="modal"
                          data-target="#transaction-info-{{ transaction.id }}"
                        >
                          Informacion</a
                        >

                        <a
                          @click="approved(transaction)"
                          class="btn btn-success btn-xs"
                          >Procesar</a
                        >
                        <a
                          @click="cancel(transaction)"
                          class="btn btn-danger btn-xs"
                          >Desestimar</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <template v-if="loadingTable">
                  <div style="text-align: center">
                    <span class="fa fa-spin fa-spinner"></span>
                  </div>
                </template>
              </div>
            </div>
            <!--</div>-->
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER   -->
    <footer class="footer b-t b-grey">
      <div class="copyright">
        2016 &copy; Cash Depot - Todos los derechos reservados.
      </div>
    </footer>

    <div
      v-for="transaction in transactions"
      class="modal fade"
      id="transaction-info-{{transaction.id}}"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true"> &times; </span>
            </button>
            <h4 class="modal-title">Información de la transacción</h4>
          </div>
          <div class="modal-body">
            <table class="table table-striped">
              <tbody>
                <tr>
                  <td>Nombre Empleado:</td>
                  <td>{{ transaction.client_name }}</td>
                </tr>
                <tr>
                  <td>Compañia:</td>
                  <td>{{ transaction.company_name }}</td>
                </tr>
                <tr>
                  <td>Productos:</td>
                  <td>
                    {{ transaction.providers.name }} -
                    {{ transaction.offers.title }}
                  </td>
                </tr>
                <tr>
                  <td>Monoto Solicitado:</td>
                  <td>{{ transaction.request_amount | currency }}</td>
                </tr>
                <tr>
                  <td>Numero de Contrato:</td>
                  <td>{{ transaction.contract }}</td>
                </tr>
                <tr>
                  <td>Descripcion de la Solicitud:</td>
                  <td>{{ transaction.description }}</td>
                </tr>
                <tr>
                  <td>Fecha de la Solicitud:</td>
                  <td>{{ transaction.date }}</td>
                </tr>
              </tbody>
            </table>
            <div class="clearfix"></div>
          </div>
          <div class="modal-footer text-center">
            <div class="row">
              <div class="col-md-12">
                <a data-dismiss="modal" class="btn btn-bgrey">Cerrar</a>
                <a @click="approved(transaction)" class="btn btn-success"
                  >Aprobar</a
                >
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      api_url: `http://api.cashdepotint.com/v1`,
      checkedComment: [],
      validity: "",
      loadingTable: true,
      transactions: [],
      visibleColumns: [],
      vid: false,
      selectedColumns: "",
      user_id: "",
    };
  },
  created() {
    this.user_id = this.$route.query.id;

    if (!this.user_id) {
      this.user_id = window.localStorage.getItem("user_id");
    } else {
      window.localStorage.setItem("user_id", this.user_id);
    }

    this.getTransactions();
  },
  methods: {
    getTransactions: function () {
      this.$http
        .get(
          apiUrl +
            `/services/transactions?q=(status:0)&relationships=offers,providers`
        )
        .then(
          (response) => {
            this.transactions = response.body;
            this.loadingTable = false;
          },
          (response) => {
            sweetAlert(
              "Oops...",
              "Ha ocurrido un error al cargar las transacciones !",
              "error"
            );
          }
        );
    },
    approved(transaction) {
        this.loadingTable = true;
        this.$http({
          emulateJSON: true,
          emulateHTTP: true,
          url: apiUrl + `/services/` + transaction.id + `/status`,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: { status: 1 },
        }).then(
          function (response) {
            sweetAlert("Todo correcto", "Transaccion procesada", "success");
            this.getTransactions();
            this.loadingTable = false;
          },
          (response) => {
            sweetAlert("Oops...", "Ha ocurrido un error !", "error");
          }
        );
    },
    cancel(transaction) {
        this.loadingTable = true;

        this.$http({
          emulateJSON: true,
          emulateHTTP: true,
          url: apiUrl + `/services/` + transaction.id + `/status`,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: { status: 2 },
        }).then(
          function (response) {
            sweetAlert("Todo correcto", "Transaccion cancelada", "success");
            this.getTransactions();
            this.loadingTable = false;
          },
          (response) => {
            sweetAlert("Oops...", "Ha ocurrido un error !", "error");
          }
        );
    },
  },
};
</script>

<style scoped>
.txt-blue {
  color: #0000ee;
}
</style>



// WEBPACK FOOTER //
// services.vue?b11d8300